import React from 'react'
import './User_SetLogoState_Card.css'
import agent from "../../../agent";
import image_placeholder from '../../../images/image_placeholder.svg'
import vote_bg from '../../../images/votes/default.svg'
import {CURRENT_USER_COLOR, CURRENT_USER_TEXT} from "../../../constants/Constants";

class User_SetLogoState_Card extends React.Component{

    sendVote(){
        this.props.onCardClick(this.props.user.uuid);
    }
    render() {
        let hasntImage = this.props.user.image === '';
        let imageSrc = hasntImage ? image_placeholder : agent.FILES_ROOT + this.props.user.image;
        let username = `${this.props.user.firstname} ${this.props.user.lastname}`;
        let borderStyle = {};
        let textStyle = {}
        if(this.props.isCurrentPlayer){
            username += CURRENT_USER_TEXT
            borderStyle = {
                    border: '1px solid ' + CURRENT_USER_COLOR
            }
            textStyle = {
                fontWeight: 'bold'
            }
        }

        let votes = ""
        let textVoteStyle = {}
        let hasYourVote = this.props.votes && this.props.votes.includes(this.props.currentPlayerId);
        if(hasYourVote){
            textVoteStyle = {
                color:'#F29C14'
            }
        }
        if(this.props.votes){
            votes = <div className='user-set-logo-image-vote-container'>
                <img alt={"icon"} src={vote_bg} style={{
                    width:'50px',
                    height:'50px'
                }}/>
                <div className='user-set-logo-image-vote-text' style={textVoteStyle}>
                    {this.props.votes.length}
                </div>
            </div>
        }
        return <div className='user-set-logo-card-container' onClick={this.sendVote.bind(this)}>
            <div className='user-set-logo-image-container' style={borderStyle}>
                <img alt={"icon"} src={imageSrc} className={hasntImage ? 'user-set-logo-image-placeholder' : 'user-set-logo-image'} />
                <div className={'user-set-logo-image-darker'}>
                        Нажмите, если<br/>
                        хотите проголосовать<br/>
                        за этот логотип<br/>

                </div>
                {votes}

            </div>
            <div className='user-set-logo-image-username' style={borderStyle}>
                <div className='user-set-logo-username' style={textStyle}>
                    {username}
                </div>
            </div>
        </div>
    }
}
export default User_SetLogoState_Card;
